import React from 'react';
import PropTypes from 'prop-types';
import { usePOCreation } from '../contextProvider/POCreationContext';
import ControlRendererForPO from './ControlRendererForPO';

export default function SectionForPO({ section, isPreviewMode = false }) {
  if (!section) {
    return null;
  }

  const sectionName = section?.name || `Section ${section?.id}`;

  return (
    <div className="inner-container p-10 mb-8">
      <div className="section-template-title mb-0">{sectionName}</div>
      <div className="potemplate-section-content">
        {section?.columns?.map((controls, colIdx) => (
          <SectionColumn key={colIdx} controls={controls} sectionId={section.id} colIdx={colIdx} isPreviewMode={isPreviewMode} />
        ))}
      </div>
    </div>
  );
}

function SectionColumn({ controls, sectionId, colIdx, isPreviewMode = false }) {
  const { creationState, handleSectionValueChange } = usePOCreation();

  return (
    <div className="potemplate-section-column mb-8">
      {controls?.map((control, idx) => {
        const uniqueControlId = `${sectionId}_${colIdx}_${control.id}_${idx}`;
        const hasUserValue = creationState.sectionValues?.hasOwnProperty(uniqueControlId);
        const controlValue = hasUserValue ? creationState.sectionValues[uniqueControlId] : control.value || '';

        return (
          <div key={uniqueControlId} className="control-container">
            <ControlRendererForPO
              control={control}
              value={controlValue}
              onChange={(newValue) => handleSectionValueChange(uniqueControlId, newValue)}
              isPreviewMode={isPreviewMode}
              uniqueKey={uniqueControlId}
            />
          </div>
        );
      })}
    </div>
  );
}

SectionForPO.displayName = 'SectionForPO';

SectionForPO.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  }).isRequired,
  isPreviewMode: PropTypes.bool,
};

SectionForPO.defaultProps = {
  isPreviewMode: false,
};
